import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { ReviewProgressIcon } from '~/ui/core/stats/icons/ReviewProgressIcon';

import { StatusIndicator } from './StatusIndicator';

export const ReviewedBadge: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <StatusIndicator
            className="text-status-reviewed"
            data-testid="review-state-reviewed"
            icon={<ReviewProgressIcon colorBase="currentColor" colorFill="currentColor" progress={1} />}
        >
            {translate('pages.job-architecture-v2.job-profile-status-reviewed')}
        </StatusIndicator>
    );
};
